import React, { useState } from 'react';
import { METRIKA_GOALS, reachGoal } from '../analytics';

const THEME_COLORS = { light: '#f3f5f6', dark: '#0f1417' };

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  // На пререндере документа нет: тема там всегда светлая, в браузере её
  // выставляет инлайн-скрипт из index.html ещё до первой отрисовки.
  const [theme, setTheme] = useState(() =>
    typeof document === 'undefined'
      ? 'light'
      : document.documentElement.dataset.theme || 'light'
  );

  const toggleTheme = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    document.documentElement.dataset.theme = next;
    try {
      localStorage.setItem('theme', next);
    } catch (e) {}
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', THEME_COLORS[next]);
    setTheme(next);
  };

  const navItems = [
    { href: '#manifest', label: 'Манифест' },
    { href: '#science', label: 'Наука' },
    { href: '#school', label: 'Школа' },
    { href: '/ai/', label: 'ИИ для компаний', goal: METRIKA_GOALS.SELECT_AI },
    { href: '#talks', label: 'Выступления' },
    { href: '#contacts', label: 'Контакты' },
  ];

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="site-header">
      <div className="header-content">
        <a className="brand" href="#top" aria-label="glotov.pro" onClick={closeMenu}>
          <span className="brand-mark">AG</span>
          <span>glotov.pro</span>
        </a>
        <nav className="header-nav" aria-label="Основная навигация">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              target={item.external ? '_blank' : undefined}
              rel={item.external ? 'noopener noreferrer' : undefined}
              data-metrika-goal={item.goal}
              onClick={item.goal ? () => reachGoal(item.goal) : undefined}
            >
              {item.label}
            </a>
          ))}
        </nav>
        <div className="header-side">
          <button
            type="button"
            className="theme-toggle"
            onClick={toggleTheme}
            aria-label={theme === 'dark' ? 'Включить дневную тему' : 'Включить ночную тему'}
            title={theme === 'dark' ? 'Дневная тема' : 'Ночная тема'}
          >
            {theme === 'dark' ? (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
                <circle cx="12" cy="12" r="4" />
                <path d="M12 2v2m0 16v2M4.9 4.9l1.4 1.4m11.4 11.4 1.4 1.4M2 12h2m16 0h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
              </svg>
            )}
          </button>
          <a className="header-action" href="#contacts">
            Написать
          </a>
          <button
            type="button"
            className={`menu-toggle${menuOpen ? ' is-open' : ''}`}
            aria-expanded={menuOpen}
            aria-controls="mobile-nav"
            aria-label={menuOpen ? 'Закрыть меню' : 'Открыть меню'}
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>
      <nav
        id="mobile-nav"
        className={`mobile-nav${menuOpen ? ' is-open' : ''}`}
        aria-label="Мобильная навигация"
      >
        {navItems.map((item) => (
          <a
            key={item.href}
            href={item.href}
            target={item.external ? '_blank' : undefined}
            rel={item.external ? 'noopener noreferrer' : undefined}
            data-metrika-goal={item.goal}
            onClick={() => {
              closeMenu();
              if (item.goal) reachGoal(item.goal);
            }}
          >
            {item.label}
          </a>
        ))}
      </nav>
    </header>
  );
}

export default Header;
